import { BadgeCheck, HeartHandshake, Tag } from "lucide-react";

const VALUES = [
  {
    icon: BadgeCheck,
    title: "Qualidade em primeiro lugar",
    text: "Produtos selecionados com cuidado, porque sua visão merece o melhor.",
    testid: "value-card-quality",
  },
  {
    icon: HeartHandshake,
    title: "Atendimento próximo",
    text: "Aqui você é atendido de verdade: com atenção, paciência e sem pressa.",
    testid: "value-card-care",
  },
  {
    icon: Tag,
    title: "Preço justo",
    text: "Qualidade de verdade, com um preço que cabe no seu bolso.",
    testid: "value-card-price",
  },
];

export const About = () => (
  <section
    id="sobre"
    data-testid="about-section"
    className="scroll-mt-24 bg-white"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28">
      <div className="max-w-2xl" data-reveal>
        <p
          data-testid="about-overline"
          className="text-xs font-bold uppercase tracking-[0.2em] text-brand"
        >
          A Ótica Danko
        </p>
        <h2
          data-testid="about-heading"
          className="mt-4 font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-stone-900"
        >
          Uma ótica de confiança, perto de você
        </h2>
        <p
          data-testid="about-text"
          className="mt-5 text-base sm:text-lg leading-relaxed text-stone-600"
        >
          A Ótica Danko atende Mogi Guaçu e região com um compromisso simples:
          cuidar bem da sua visão. Trabalhamos com armações e lentes de
          qualidade, atendimento próximo e preço justo — porque enxergar bem
          não deveria ser complicado.
        </p>
      </div>

      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {VALUES.map(({ icon: Icon, title, text, testid }, index) => (
          <div
            key={testid}
            data-testid={testid}
            data-reveal
            style={{ transitionDelay: `${index * 100}ms` }}
            className="group rounded-2xl border border-stone-200 bg-stone-50 p-8 hover:border-brand hover:shadow-md transition-all duration-200"
          >
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-brand-light text-brand group-hover:bg-brand group-hover:text-white transition-colors">
              <Icon className="w-6 h-6" />
            </div>
            <h3 className="mt-5 font-heading text-xl font-semibold text-stone-900">
              {title}
            </h3>
            <p className="mt-3 text-base leading-relaxed text-stone-600">
              {text}
            </p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
